import { render, staticRenderFns } from "./AddProjectGate.vue?vue&type=template&id=fc4dc296&scoped=true"
import script from "./AddProjectGate.vue?vue&type=script&lang=js"
export * from "./AddProjectGate.vue?vue&type=script&lang=js"
import style0 from "./AddProjectGate.vue?vue&type=style&index=0&id=fc4dc296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4dc296",
  null
  
)

export default component.exports